export enum AppPrivileges {
  DASHBOARD = 'IntegratedInvoicing.DASHBOARD',
  LEDGER = 'IntegratedInvoicing.LEDGER',
  CAN_CREATE_COST = 'IntegratedInvoicing.CAN_CREATE_COST',
  CAN_SUBMIT_COST = 'IntegratedInvoicing.CAN_SUBMIT_COST',
  CAN_UPDATE_COST_EQUIPMENT = 'IntegratedInvoicing.CAN_UPDATE_COST_EQUIPMENT',
  CAN_UPDATE_COST_ACCOUNTCODE = 'IntegratedInvoicing.CAN_UPDATE_COST_ACCOUNTCODE',
  CAN_UPDATE_COST_STORE = 'IntegratedInvoicing.CAN_UPDATE_COST_STORE',
  CAN_UPDATE_COST_SERVICEPROVIDER = 'IntegratedInvoicing.CAN_UPDATE_COST_SERVICEPROVIDER',
  CAN_UPDATE_COST_CAPEX = 'IntegratedInvoicing.CAN_UPDATE_COST_CAPEX',
  CAN_UPDATE_RELATED_COST = 'IntegratedInvoicing.CAN_UPDATE_RELATED_COST',
  CAN_ADD_COST_NEW_VERSION = 'IntegratedInvoicing.CAN_ADD_COST_NEW_VERSION',
  CAN_APPROVE_COST = 'IntegratedInvoicing.CAN_APPROVE_COST',
  CAN_QUERY_COST = 'IntegratedInvoicing.CAN_QUERY_COST',
  CAN_SAVE_COST = 'IntegratedInvoicing.CAN_SAVE_COST',
  REPORTS = 'IntegratedInvoicing.REPORTS',
  BULKUPLOAD = 'IntegratedInvoicing.BULKUPLOAD',
  BACKTOETECH = 'IntegratedInvoicing.BACKTOETECH',
  CAN_FILTER_BY_STORE = 'IntegratedInvoicing.CAN_FILTER_BY_STORE',
  CAN_FILTER_BY_MCDIENSTEN_ID = 'IntegratedInvoicing.CAN_FILTER_BY_MCDIENSTEN_ID',
  CAN_FILTER_BY_SERVICE_PROVIDER = 'IntegratedInvoicing.CAN_FILTER_BY_SERVICE_PROVIDER',
  LOGOUT = 'IntegratedInvoicing.LOGOUT',
}
